const blockComponentControllers = import.meta.glob("./**/*_controller.js", {
  eager: true,
})

export default blockComponentControllers
